import { RootState } from '../Application';
import { isConfigReady } from '../domain/Config/Conditions';
import { hasActiveProduct } from '../domain/Order/Conditions';
import { app } from '../initApp';
import { Condition } from '../screen/Condition';
import { UseCase } from './usecase/UseCase';

export const showCustomizeStepUseCase:UseCase = {
  type: 'SHOW_CUSTOMIZE_STEP',

  checkConditions: ( state: RootState ) => {
    return Condition.evaluate(state, [isConfigReady, hasActiveProduct]);
  },

  run: () => {
    // @ts-ignore
    return Cx.resolve();
  }
};

export function canShowCustomizeStep(state: RootState) {
  return showCustomizeStepUseCase.checkConditions( state ).isAllowed;
}

export function showCustomizeStep(){
  app.runUseCase(showCustomizeStepUseCase);
}
